const useResourceAuthorization = (resource) => {
    const newRecord = resource?.id === null || resource?.id === undefined;

    return {
        edit: newRecord || Boolean(resource?.authorization?.update),
        update: Boolean(resource?.authorization?.update),
        delete: Boolean(resource?.authorization?.delete),
    }
}

export default useResourceAuthorization;